export type EnterType = 'ecommerce' | 'community'

export interface MenuItem {
  name: string
  path?: string
  type?: EnterType
  isGroup?: boolean
  children?: MenuItem[]
  id?: number | string
  icon?: string
  parentId?: number
}

export interface UserMenuItem {
  id?: number | string
  name: string
  icon: string
  path?: string
  type?: EnterType
  children?: UserMenuItem[]
}

export const menuList: MenuItem[] = [
  {
    name: '社区',
    path: '/',
    type: 'community',
    id: 1,
    icon: 'hitems-home-tab'
  },
  {
    name: '创作者',
    path: '/creator',
    type: 'community',
    id: 6,
    icon: 'hitems-menu-creator'
  },
  // {
  //   name: '申请好物设计师',
  //   path: '/author/onboarding',
  //   type: 'community',
  //   id: 2,
  //   icon: 'hitems-edit-img-inpainting'
  // },
  {
    name: '商城',
    path: '/',
    type: 'ecommerce',
    id: 3,
    icon: 'hitems-menu-shop'
  },
  {
    name: '其他',
    isGroup: true,
    id: 4,
    children: [
      {
        name: '造物模式升级',
        id: 41,
        icon: 'hitems-menu-about-us',
        children: [
          {
            name: '如何造好物',
            path: '/courseForMakeIt',
            type: 'community',
            id: 412,
            parentId: 41
          },
          {
            name: '造好物模式升级',
            path: '/createUpgrade',
            type: 'community',
            id: 415,
            parentId: 41
          },
          {
            name: '工具教程',
            path: '/tool',
            type: 'community',
            id: 414,
            parentId: 41
          },
          {
            name: '关于我们',
            path: '/about',
            type: 'community',
            id: 411,
            parentId: 41
          }
        ]
      }
    ]
  },
  {
    name: '我的',
    isGroup: true,
    id: 5,
    children: [
      {
        name: '创作历史',
        path: '/my-history',
        type: 'community',
        id: 51,
        parentId: 5,
        icon: 'hitems-menu-history'
      },
      { name: '消息', path: '', id: 52, parentId: 5, icon: 'hitems-menu-notice' }
    ]
  }
]

export const userMenuList: UserMenuItem[] = [
  {
    id: 'mine',
    name: '个人主页',
    icon: 'hitems-wode',
    path: '/account',
    type: 'community'
  },
  {
    id: 'order',
    name: '我的订单',
    icon: 'hitems-order',
    path: '/order/list',
    type: 'ecommerce'
  },
  {
    id: 'logout',
    name: '退出登录',
    icon: 'hitems-logout1'
  }
]
